import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const ProductsDisplayed = ({ product }) => {
  const {
    id,
    brand,
    brand_id,
    color,
    description,
    image_url,
    material,
    price,
    qty,
    sku,
    title,
    type_id,
    user_id,
  } = product;
  console.log("clg props inside prod displ", product);

  //   const [product, setProduct] = useState();
  //   useEffect(() => {
  //     setProduct(detail);
  //   }, [detail]);
  //   console.log("ProductsDisplayed", props);
  return (
    <div className="product-wrap">
      <Link to={`/products/${id}`}>
        <div className="product">
          <div className="circle">
            <img src={image_url} />
          </div>
        </div>
      </Link>

      <div className="title">{title}</div>
      <div className="price">${price}</div>
    </div>
  );
};

export default ProductsDisplayed;
